/* Helper Functions */

// Add an event listener to an element.
export function addListener(event, elements, handler, useCapture = false) {
    [...elements].map(element => element.addEventListener(event, handler, useCapture));
}

// Create a DOM element.
export function createElement(element, className = false) {
    const el = document.createElement(element);

    if (className) {
        el.className = className;
    }

    return el;
}

// Is an object empty
export function isEmpty(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
    let timeout;

    return () => {
        const args = arguments;
        const context = this;
        const later = function() {
            timeout = null;

            if (! immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
}

// Load SVG with the correct require context.
export function fileLoader(rc) {
    return (context => {
        return context.keys().reduce((o, k, i) => {
            o[k] = context.keys().map(context)[i];
            return o;
        }, {});
    })(rc);
}

// This function assumes the use of Bootstrap 4.
export function toggleGridViewer(container = 'container') {
    document.head.insertAdjacentHTML('beforeend',
        `<style type="text/css">
            #grid-overlay {
                position: absolute;
                top: 0;
                width: 100%;
                z-index: 10001;
            }
            #grid-overlay .col {
                background: rgba(0, 255, 255, .2);
            }
            #grid-overlay .fill {
                background: rgba(0, 255, 255, .4);
                height: 6000px;
                margin: 0;
                padding: 0;
            }
        </style>`
    );

    document.body.insertAdjacentHTML('afterbegin',
        `<div id="grid-overlay" class="d-none">
            <div class="${container}">
                <div class="row">
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                    <div class="col col-md-1"><p class="fill"></p></div>
                </div>
            </div>
        </div>`
    );

    document.addEventListener('keypress', (event) => {
        switch (event.key) {
            case 'g':
                document.getElementById('grid-overlay').classList.toggle('d-none');
                break;
        }
    });
}
